import { createSlice } from "@reduxjs/toolkit";

interface initialCountryData {
  data: any;
}

const initialCountryData: initialCountryData = {
  data: [],
};
const countrySlice = createSlice({
  name: "country",
  initialState: initialCountryData,
  reducers: {
    setCountry: (state, action: any) => {
      state.data = action.payload;
    },
  },
});

export const { setCountry } = countrySlice.actions;
export { countrySlice as countrySlice };
